import {
  makeStyles,
  tokens,
  shorthands,
} from '@fluentui/react-components';

export const useStyles = makeStyles({
  blockUiContainer: {
    position: 'relative',
    width: '100%',
    height: '100%',
    '&.react-block-ui': {
      overflow: 'hidden',
        '& .ui-blocker-overlay': {
          position: 'sticky',
          top: 0,
        },
    },
  },
  blockUiOverlay: {
    position: 'absolute',
    backgroundColor: tokens.colorNeutralBackgroundAlpha2,
    zIndex: 1010,
    textAlign: 'center',
    width: '100%',
    height: '100%',
    cursor: 'wait',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...shorthands.inset(0),
    ...shorthands.overflow('hidden'),
    '&:focus': {
      ...shorthands.outline('none'),
    },
  },
  blockerIndicator: {
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.border('1px', 'solid', tokens.colorTransparentStroke),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    ...shorthands.padding('12px'),
    '& svg .fui-Spinner__Tail': {
      animationDuration: '2s !important',
      animationIterationCount: 'infinite !important',
    },
  },
});
